import React, { useEffect, useState, type FC } from 'react';

import { faSignOut } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'classnames';

import AVATAR from '@root/images/avatar.png';
import { Picture } from '@shared/components/helpers/picture';
import { ImgixCrop, ImgixFit } from '@shared/utils/imgix';

import { useUser } from '@admin/hooks/use_user';

const SIGN_OUT_URL = '/users/sign_out';

export const NavBarDropdown: FC = () => {
  const [open, setOpen] = useState(false);
  const user = useUser();

  useEffect(() => {
    if (!open) return;

    const listener = () => {
      setOpen(false);
    };

    document.addEventListener('click', listener);
    return () => {
      document.removeEventListener('click', listener);
    };
  }, [open]);

  return (
    <li className={cn('dropdown', open && 'open')} id="dropdown-user">
      <a
        href="#"
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          setOpen((open) => !open);
        }}
        className="dropdown-toggle text-right"
      >
        <span className="pull-right">
          <Picture
            className="img-circle img-user media-object"
            crop={ImgixCrop.Faces}
            fit={ImgixFit.Crop}
            source={user.image_source}
            width={32}
            height={32}
            fallback={AVATAR}
          />
        </span>
        <div className="username hidden-xs">{user.name}</div>
      </a>

      <div
        className="dropdown-menu dropdown-menu-right with-arrow panel-default"
        onClick={(event) => {
          event.stopPropagation();
        }}
      >
        <div className="pad-all text-right">
          <a href={SIGN_OUT_URL} target="_self" className="btn btn-primary">
            <FontAwesomeIcon icon={faSignOut} /> Logout
          </a>
        </div>
      </div>
    </li>
  );
};
